/***
 * 创建人：李珊
 * 时间：2021-05-28
 * 描述：人物生平管理：查看详情操作
 * 更新说明:
 */
import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
import { KmsEnum } from '../../../serves/kms-enum';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { EditDatasourceComponent } from '../../edit-datasource/edit-datasource.component';

@Component({
  selector: 'app-tab-info-view',
  templateUrl: './tab-info-view.component.html',
  styleUrls: ['./tab-info-view.component.css']
})
export class TabInfoViewComponent implements OnInit {

  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param: any;
  @Output() callback = new EventEmitter(); //抛出事件
  // 模态框标题名称
  title = '';
  // 属性配置
  attrDatas:any = {}
  // 表单详情信息
  formData: any = {};
  // 相关实体数据
  relatedInstance:any = [];
  // 地理位置信息
  places:any = [];
  // 表单控件类型
  formControlTypes = KmsEnum.FORM_CONTROL_TYPES;
  // 数据来源
  sourceList:any = [];
  constructor(
    private box: SwMassageBoxService,  //消息提示框
    private instanceModuleService: InstanceModuleService,
    private kmsService: KmsService,   //请求服务
    private create: SwCreateModalComponentService,
  ) {

  }

  ngOnInit() {
    this.attrDatas = JSON.parse(JSON.stringify(this.param.attrDatas));
    this.title = `查看${this.attrDatas.attributeName}`;
    this.clickLoca();
  }

  clickLoca() {
    this.kmsService.queryCompositeAttributeById(this.param.nodeId).subscribe(
      data => {
        if(data.code == '200'){
          this.formData = data.data.properties;
          this.relatedInstance = data.data.relevantRelationships;
          this.places = data.data.places;
          this.sourceList = data.data.compositeRels ? data.data.compositeRels : [];
          if(this.sourceList.length>0){
            this.sourceList.forEach(element => {
              element['uuid'] = this.instanceModuleService.uuid2();
            });
          }
        }else{
          this.box.waring(data.msg);
        }
      }
    )
  }

  // 根据属性的字段类型转换属性值
  getAttrValue(item){
    let str = '';
    // 字典类型
    if(item.fieldType == this.formControlTypes.dropBox){
      str = this.instanceModuleService.getDictionaryName(item.dictOptions,this.formData[item.englishCode]);
      return str;
    }
    // 树形下拉框字典类型
    else if(item.fieldType == this.formControlTypes.treeSelect){
      str = this.instanceModuleService.getDictionaryName(item.dictOptions,this.formData[item.englishCode]);
      return str;
    }
    // 选择框类型（相关实体）
    else if(item.fieldType == this.formControlTypes.selectBox){
      str = '';
      if(this.relatedInstance){
        let relatedInstance = this.relatedInstance;
        for(let i=0;i<relatedInstance.length;i++){
          str += (i==0 ? relatedInstance[i].instanceName : ','+relatedInstance[i].instanceName);
        }
      }
      return str ? str : '无';
    }
    // 单选
    else if(item.fieldType == this.formControlTypes.radio){
      if(item.dictOptions.length > 0){
        let vals = item.dictOptions.filter(el => el.id == this.formData[item.englishCode]);
        str = vals.length>0 ? vals[0].text : '无';
        return str;
      }else{
        return '无';
      }
    }
    // 地理位置
    else if(item.fieldType == this.formControlTypes.geoRemark || item.fieldType == this.formControlTypes.geo){
        if(this.places){
          for(let i=0;i<this.places.length;i++){
            str += (i==0 ? this.places[i].placeName : ','+this.places[i].placeName);
          }
        }
        return str ? str : '无';
    }
    else{
      return '无';
    }
  }

  // 查看来源方法
  handleSourceEditClick() {
    const data = {
        state: 'view',
        sourceList: this.sourceList
    }
    this.create.createModal(EditDatasourceComponent, data);
  }
}



